import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { asyncRoutes } from '@/router'
import { useAuthStore } from './auth'

export const usePermissionStore = defineStore('permission', () => {
  const routes = ref<RouteRecordRaw[]>([])

  function filterRoutesByRoles(routeList: RouteRecordRaw[], roles: string[]): RouteRecordRaw[] {
    return routeList.filter((route) => {
      const routeRoles = route.meta?.roles as string[] | undefined
      if (!routeRoles || routeRoles.length === 0) return true
      return roles.some((role) => routeRoles.includes(role))
    })
  }

  async function generateRoutes() {
    const authStore = useAuthStore()
    const accessedRoutes = filterRoutesByRoles(asyncRoutes, authStore.roles)
    routes.value = accessedRoutes
    return accessedRoutes
  }

  function resetRoutes() {
    routes.value = []
  }

  return { routes, generateRoutes, resetRoutes }
})
